// Sidebar icon for Buckets, in the platform's outline style (24px, stroke 2).
export const bucketsIcon = (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 7l1.6 11.2A2 2 0 0 0 7.6 20h8.8a2 2 0 0 0 2-1.8L20 7" />
    <ellipse cx="12" cy="7" rx="8" ry="3" />
  </svg>
);
